import { render, staticRenderFns } from "./PasswordResetLink.vue?vue&type=template&id=123af144&scoped=true&"
import script from "./PasswordResetLink.vue?vue&type=script&lang=js&"
export * from "./PasswordResetLink.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetLink.vue?vue&type=style&index=0&id=123af144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123af144",
  null
  
)

export default component.exports